import { render, staticRenderFns } from "./Gifted.vue?vue&type=template&id=05f4551c&scoped=true&"
import script from "./Gifted.vue?vue&type=script&lang=js&"
export * from "./Gifted.vue?vue&type=script&lang=js&"
import style0 from "./Gifted.vue?vue&type=style&index=0&id=05f4551c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4551c",
  null
  
)

export default component.exports